import { Injectable } from '@angular/core';
import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class DatepickerService {

  get todayInNgbDateStruct(): NgbDateStruct {
    const today: Date = new Date()
    return {
      day: today.getUTCDate(),
      month: today.getMonth() + 1,
      year: today.getFullYear()
    }
  }

  get todayInStringForDatepicker(): string {
    const today: Date = new Date()
    return `${today.getUTCDate()}-${today.getMonth() + 1}-${today.getFullYear()}`
  }

  convertNgbDateToString(ngbDate: NgbDate): string {
    return `${ngbDate.day}-${ngbDate.month}-${ngbDate.year}`
  }

  convertDateFromDatabaseToDatepickerStringFormat(date: string): string {
    const dateParts: string[] = date.split('-')
    return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
  }

  convertDateFromDatepickerStringFormatToDatabaseFormat(date: string): string {
    const dateParts: string[] = date.split('-')
    return `${dateParts[1]}-${dateParts[0]}-${dateParts[2]}`
  }

  convertDateInStringFormatToNgbDateStruct(date: string): NgbDateStruct {
    //date comes in format "mm-dd-yyyy" (standard format in frontend)
    let dateParts: string[] = date.split('-')
    return {
      day: parseInt(dateParts[1]),
      month: parseInt(dateParts[2]),
      year: parseInt(dateParts[0])
    }
  }

  constructor() { }
}
